// crewbit-admin/src/components/schedule/StopMarker.tsx
//
// Schedule Module Phase C C4 — map-marker overlay (admin). Body parallel to
// mobile StopMarker.tsx modulo runtime; mapbox-gl marker wraps this component
// supplying coordinate. This file is the visual shell.

import { palette } from '../../styles/tokens';

export interface StopMarkerProps {
  index: number;
  status?: string;
  density?: 'compact' | 'normal';
}

function statusColor(status?: string): string {
  if (status === 'completed') return palette.green;
  if (status === 'in_progress') return palette.accent;
  if (status === 'cancelled') return palette.g400;
  if (status === 'red' as never) return palette.red;
  return palette.accent;
}

export function StopMarker({ index, status, density = 'normal' }: StopMarkerProps) {
  const size = density === 'compact' ? 22 : 28;
  return (
    <div
      role="img"
      aria-label={`Stop ${index}${status ? `, ${status}` : ''}`}
      style={{
        width: size, height: size, borderRadius: size / 2,
        backgroundColor: statusColor(status),
        border: `2px solid ${palette.white}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: palette.white,
        fontWeight: 700, fontSize: 12,
      }}
    >
      {index}
    </div>
  );
}
